var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2091e1b3e35cba6cb38c9e09a22eb8ec19082f91"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["poryadok-ru@sentry"]={id:"2091e1b3e35cba6cb38c9e09a22eb8ec19082f91"};
      